import type {
  ArdoqId,
  FutureState,
  FutureStateEvent,
  FutureStatePreview,
  Initiative,
} from '@ardoq/api-types';

const toFutureStatePreview = (
  futureState: FutureState
): FutureStatePreview => ({
  _id: futureState._id,
  name: futureState.name,
  description: futureState.description,
  approval: futureState.approval,
  estimatedCost: futureState.estimatedCost,
  estimatedRisk: futureState.estimatedRisk,
  created: futureState.created,
  owners: futureState.owners,
  assignedTo: futureState.assignedTo,
  _version: futureState._version,
});

/** Each helper returns the initiative unchanged when the future state does not apply. */
export const mergeFutureStatePreview = (
  initiative: Initiative,
  futureState: FutureState
): Initiative => {
  const { futureStates } = initiative;
  const index = futureStates.findIndex(
    preview => preview._id === futureState._id
  );
  if (index === -1 || futureState._version < futureStates[index]._version) {
    return initiative;
  }
  return {
    ...initiative,
    futureStates: futureStates.with(index, toFutureStatePreview(futureState)),
  };
};

export const addFutureStatePreview = (
  initiative: Initiative,
  futureState: FutureStateEvent
): Initiative => {
  if (futureState.initiativeId !== initiative._id) return initiative;
  if (
    initiative.futureStates.some(preview => preview._id === futureState._id)
  ) {
    return initiative;
  }
  return {
    ...initiative,
    futureStates: [
      ...initiative.futureStates,
      toFutureStatePreview(futureState),
    ],
  };
};

export const removeFutureStatePreview = (
  initiative: Initiative,
  futureStateId: ArdoqId
): Initiative => {
  if (!initiative.futureStates.some(preview => preview._id === futureStateId)) {
    return initiative;
  }
  return {
    ...initiative,
    futureStates: initiative.futureStates.filter(
      preview => preview._id !== futureStateId
    ),
  };
};
